import { MutationAction, VuexModule, getModule, Module } from 'vuex-module-decorators'
import store from '@/store/index'
import { Badge } from '@/domain/Badge'

export interface BadgeStateModuleInterface {
    /* 未開始の理化学検査数 */
    chemistryInspectionCount: number;
    /* 未開始の微生物検査数 */
    microbialInspectionCount: number;
}

/**
 * バッジ情報
 */
@Module({
    dynamic: true,
    store,
    name: "BadgeStateModule",
    namespaced: true,
})
class BadgeState extends VuexModule implements BadgeStateModuleInterface {
    /* 未開始の理化学検査数 */
    chemistryInspectionCount = 0
    /* 未開始の微生物検査数 */
    microbialInspectionCount = 0

    /**
     * バッジ情報のセット
     * @param chemistryInspectionCount
     * @param microbialInspectionCount
     */
    @MutationAction({ mutate: ["chemistryInspectionCount", "microbialInspectionCount"] })
    public async setBadge(badge: Badge) {
        return {
            chemistryInspectionCount: badge.chemistryInspectionCount,
            microbialInspectionCount: badge.microbialInspectionCount,
        }
    }

    /**
     * バッジ情報のクリア
     */
    @MutationAction({ mutate: ["chemistryInspectionCount", "microbialInspectionCount"] })
    public async clearBadge() {
        return {
            chemistryInspectionCount: 0,
            microbialInspectionCount: 0,
        }
    }
}

export const BadgeStateModule = getModule(BadgeState);



